import {React} from 'external/react'
import {
  clsx,
  makeStyles,
  useTheme,
  Button,
  Box,
  FormControlLabel,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  useMediaQuery,
  WarningIcon,
} from 'external/material'
import {createPost} from 'helpers/command'

const useStyles = makeStyles(notificationStyles)
const useTitleStyles = makeStyles(titleStyles)

export default function Notification ({open, context, notificationPrefix}) {

  const {preferences, translate, updateState} = context

  const classes = useStyles()
  const titleClasses = useTitleStyles()
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'))

  const [stopNotification, setStopNotification] = React.useState(false)

  async function onConfirm () {
    const {preferences: {properties}} = await updateState({preferences: {properties: {notifications: {[notificationPrefix]: {$set: true}}}}})
    if (stopNotification)
      createPost('public', 'preferences')({properties})
  }

  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={e => close(e)}
      aria-labelledby={`${notificationPrefix}-notification-dialog-title`}
    >
      <DialogTitle id="tobar-notification-dialog-title" classes={titleClasses}>
        <Box className={classes.icon}><WarningIcon /></Box>
        <Box>{translate(`${notificationPrefix}-notification-dialog-title`)}</Box>
      </DialogTitle>

      <DialogContent className={classes.content}>
        <div className={classes.notification} dangerouslySetInnerHTML={{__html: translate(`${notificationPrefix}-notification-html`)}} />
      </DialogContent>

      <DialogActions className={classes.actions}>
        <FormControlLabel
          size="small"
          className={classes.stopNotification}
          control={
            <Checkbox
              size="small"
              color="primary"
              checked={stopNotification} 
              onChange={e => setStopNotification(e.target.checked)}
            />
          }
          label={translate('stop-showing')}
        />
        <div className={classes.filler} />
        <Button
          variant="contained"
          color="primary"
          className={clsx(classes.button, "confirm")}
          onClick={onConfirm}>
            {translate('continue')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

function titleStyles(theme) {
  return {
    root: {
      display: 'flex',
      justifyContent: 'center',
      fontSize: '16pt',
      fontWeight: 'bold',
      borderBottom: 'solid 1px #f3f3f3',
      background: '#fdfdfd'

    }
  }
}

function notificationStyles(theme) {
  return {
    icon: {
      color: 'red',
      fontSize: '15pt',
      marginTop: -1,
      marginRight: 10
    },
    notification: {
      padding: '0 15px',
      "& ol": {
        padding: '8px 40px'
      },
      "& li": {
        marginTop: 10,
        "&:first-child": {
          marginTop: 0
        }
      }
    },
    actions: {
      padding: 12,
      display: 'flex',
      borderTop: 'solid 1px #f3f3f3',
      background: '#fdfdfd'
    },
    filler: {
      flexGrow: 1
    },
    button: {
      textTransform: 'none'
    }
  }
}

